import type React from "react"

export const Download: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Download</title>
    <path
      d="M14 9.5H12.3125L10.8125 11H14C14.25 11 14.5 11.25 14.5 11.5V14C14.5 14.2812 14.25 14.5 14 14.5H2C1.71875 14.5 1.5 14.2812 1.5 14V11.5C1.5 11.25 1.71875 11 2 11H5.15625L3.65625 9.5H2C0.875 9.5 0 10.4062 0 11.5V14C0 15.125 0.875 16 2 16H14C15.0938 16 16 15.125 16 14V11.5C16 10.4062 15.0938 9.5 14 9.5ZM13.5 12.75C13.5 12.3438 13.1562 12 12.75 12C12.3125 12 12 12.3438 12 12.75C12 13.1875 12.3125 13.5 12.75 13.5C13.1562 13.5 13.5 13.1875 13.5 12.75ZM7.46875 11.5312C7.59375 11.6875 7.78125 11.75 8 11.75C8.1875 11.75 8.375 11.6875 8.5 11.5312L12.75 7.28125C13.0625 7 13.0625 6.53125 12.75 6.25C12.4688 5.9375 12 5.9375 11.7188 6.25L8.75 9.21875V0.75C8.75 0.34375 8.40625 0 8 0C7.5625 0 7.25 0.34375 7.25 0.75V9.21875L4.25 6.21875C3.9375 5.9375 3.46875 5.9375 3.1875 6.21875C2.875 6.53125 2.875 7 3.1875 7.28125L7.46875 11.5312Z"
      fill="#79767A"
    />
  </svg>
)
